import { render, staticRenderFns } from "./restorePassword.vue?vue&type=template&id=561c9e62&scoped=true"
import script from "./restorePassword.vue?vue&type=script&lang=js"
export * from "./restorePassword.vue?vue&type=script&lang=js"
import style0 from "./restorePassword.vue?vue&type=style&index=0&id=561c9e62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561c9e62",
  null
  
)

export default component.exports